// import Swiper JS
import Swiper from 'swiper/bundle';


let mySwiper = new Swiper ('.mySwiper', {
  // デフォルトの設定
  effect: "coverflow",
  loop: true,
  autoplay: {
    delay: 4000,
  },
  speed: 600,
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: "auto",
  coverflowEffect: {
    rotate: 50,
    stretch: 0,
    depth: 300,
    modifier: 1,
    slideShadows: true,
  },

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  breakpoints: {
    // when window width is <= 320px
    320: {
      coverflowEffect: {
        depth: 0,
      },
    },
    // when window width is <= 640px
    640: {
      coverflowEffect: {
        depth: 100,
      },
    },

    1500: {
      coverflowEffect: {
        depth: 300,
      },
    }
  }
})
